"use client";
import { EditorContent, useEditor } from "@tiptap/react";
import i18n from "i18next";
import { useEffect, useMemo, useRef } from "react";

import { EditorContext } from "../../context/EditorContext.js";

import i18next from "i18next";
import Text from '@tiptap/extension-text'
import Highlight from '@tiptap/extension-highlight'
import { AICommand, Heading, Paragraph, StarterKit } from "../../extensions/index.js";
import OneLiner from "./components/OneLiner.js";
import { AdditionalContextType, TiptapProps } from "./types.js";
import { AITextMenu } from "../menus/TextMenu/AITextMenu.js";

const DEFAULT_LANG = "en"

export const OneLineEditor = ({
  handleChange,
  content,
  additionalContext,
  isEditable = true,
  autoFocus = true,
  dir,
}: TiptapProps & {
  additionalContext?: AdditionalContextType;
  autoFocus?: boolean;
  isEditable?: boolean;
  dir?: "ltr" | "rtl" | "auto";
}) => {
  const menuContainerRef = useRef(null);
  const editorRef = useRef<HTMLDivElement>(null);

  const editor = useEditor(
    {
      content: content?.json ?? content ?? {},
      immediatelyRender: false,
      autofocus: autoFocus ?? true,
      editable: isEditable ?? true,
      onCreate: ({ editor }) => ({
        // provider?.on('synced', () => {
        //   if (editor.isEmpty) {
        //     editor.commands.setContent(initialContent)
        //   }
        // })
      }),
      extensions: [
        OneLiner,
        Text,
        Paragraph,
        AICommand,
        Highlight

      ],
      editorProps: {
        attributes: {
          languages: i18next.language,
          autocomplete: "off",
          autocorrect: "off",
          autocapitalize: "off",
          class: "min-h-full",
        },
      },
      onUpdate: ({ editor }) => {
        handleChange(editor?.getJSON() ?? {});
      },
    },
    []
  );


  const providerValue = useMemo(() => {
    return {};
  }, []);
  useEffect(() => {
    if (!additionalContext) {
      i18n.init({
        fallbackLng: DEFAULT_LANG,
        lng: DEFAULT_LANG,
        returnEmptyString: true,
        resources: {},
      });
      return
    }

    if (additionalContext.language && additionalContext.translations) {
      i18n.init({
        fallbackLng: additionalContext.language,
        lng: additionalContext.language,
        returnEmptyString: true,
        resources: {
          [additionalContext.language]: {
            translation: additionalContext.translations,
          },
        },
      });
      return
    }
    if (additionalContext.language) {
      i18n.init({
        fallbackLng: additionalContext?.language,
        lng: additionalContext?.language,
        returnEmptyString: true,
        resources: {},
      });
    }
  }, []);

  return (
    editor && (
      <EditorContext.Provider value={providerValue}>
        <div
          className="flex h-full overflow-visible"
          ref={menuContainerRef}
          dir={i18next.dir()}
        >
          <div className="one-liner relative flex flex-col flex-1 h-full  justify-center items-center ">
            <EditorContent
              dir={i18next.dir()}
              editor={editor}
              ref={editorRef}
              className="flex-1 overflow-y-visible w-full h-full outline-none outline-offset-0"
              style={{
                outline: "none",
              }}
            />
            {isEditable && (
              <>
                <AITextMenu
                  editor={editor}
                  dir={i18next.dir()}
                />
              </>
            )}
          </div>
        </div>
      </EditorContext.Provider>
    )
  );
};

export default OneLineEditor;
